'use strict';

import $ from 'jquery';
import 'what-input';
import 'slick-carousel';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.

window.jQuery = $;

require('./lib/viewport'); // Voeg een class toe als element in beeld is (optioneel).
require('foundation-sites');
require('lazyload');

// If you want to pick and choose which modules to include, comment out the above and uncomment the line below, go to the file and comment :
// import './lib/foundation-explicit-pieces';

$(document).ready(function() {
	// Custom jQuery code here
	lazyload();
	stickyNav();

	var body = $('body');

	setTimeout(function() {
		$('.loading').fadeOut();
		body.removeClass('preload');
		body.addClass('loaded');
	}, 300);

	// SLIDER
	$('.slider').slick({
		// normal options...
		infinite: false,
		// the magic
		responsive: [{
			breakpoint: 1024,
			settings: {
				infinite: true
			}
		}, {
			breakpoint: 600,
			settings: {
				dots: true
			}
		}, {
			breakpoint: 300,
			settings: 'unslick' // destroys slick
		}]
	});

	$('.slider').on('afterChange', function(event, slick, currentSlide) {
		if (currentSlide === 2) {
			$('.slick-next').addClass('hidden');
		} else {
			$('.slick-next').removeClass('hidden');
		}

		if (currentSlide === 0) {
			$('.slick-prev').addClass('hidden');
		} else {
			$('.slick-prev').removeClass('hidden');
		}
	});

	$('.school-slider').slick({
		// normal options...
		infinite: false,
		slidesToShow: 3,
		// the magic
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				infinite: true
			}
		}, {
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				dots: true
			}
		}, {
			breakpoint: 300,
			settings: 'unslick' // destroys slick
		}]
	});

	$('.school-slider').on('afterChange', function(event, slick, currentSlide) {
		if (currentSlide === 2) {
			$('.slick-next').addClass('hidden');
		} else {
			$('.slick-next').removeClass('hidden');
		}

		if (currentSlide === 0) {
			$('.slick-prev').addClass('hidden');
		} else {
			$('.slick-prev').removeClass('hidden');
		}
	});

	// SEARCH
	$('.search-button').click(function(e) {
		e.preventDefault();
		$('.search-wrapper').addClass('active');
		body.addClass('search-open');
	});

	$('.search-wrapper .close-button').click(function(e) {
		e.preventDefault();
		$('.search-wrapper').removeClass('active');
		body.removeClass('search-open');
	});

	// SCROLL TO
	$('.scroll-to').click(function(e) {
		e.preventDefault();
		var target = $(this).attr('href');
		console.log(target);
		$('html,body').animate({ scrollTop: $('' + target + '').offset().top - 80 });
	});

	// MENU
	$('.menu-button').click(function(e) {
		e.preventDefault();
		$('body').toggleClass('menu-open');
	});

	// FAQ
	$('.faq-question h5, .faq-icon').click(function(e) {
		e.preventDefault();

		var parent = $(this).closest('.faq-item');

		if (parent.hasClass('active')) {
			parent.find('.faq-extended').slideUp(300);
			parent.removeClass('active');
		} else {
			$('.faq-extended').slideUp(300);
			$('.faq-item').removeClass('active');
			parent.find('.faq-extended').slideDown(300);
			parent.addClass('active');
		}
	});

	// FUNCTIONS
	function stickyNav() {
		if ($(window).scrollTop() > 30) {
			$('body').addClass('sticky-nav');
		} else {
			$('body').removeClass('sticky-nav');
		}
	}

	$(window).scroll(function() {
		stickyNav();
	});
});

$(document).foundation();